import React from 'react';

import { Navigate, useLocation } from 'react-router';

import { appRoutes } from '@clearverify/constants';

import { useAppAuth } from 'src/hooks/auth';
import { withLoginRedirect } from 'src/utils/loginRedirect';

export const RedirectPage: React.FC = () => {
  const { isAuthorized } = useAppAuth();
  const location = useLocation();

  if (isAuthorized) {
    return <Navigate to={appRoutes.root} replace />;
  }

  const currentPath = `${location.pathname}${location.search}${location.hash}`;
  const loginUrl = withLoginRedirect(appRoutes.auth.index, currentPath);

  return <Navigate to={loginUrl} replace />;
};
